import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Asset, BaseAssetFragment, FullUserFragment, JobDetailsV2Fragment, BulkEditCalendarEventMutation, CalendarEvent_AttendeeFragment, Job_CalendarEventFragment } from 'graphql.generated';
import { JobsV2EventLocation } from 'src/app/job/job-tool.reducer';
import { EventStatuses } from 'src/app/schedules/dispatch/store/dispatch.reducer';
import { ActionSource } from 'src/app/state/action-sources';

import { EventType } from './timeline-create-event.component';

export const CreateEventDialogActions = createActionGroup({
	source: ActionSource.CREATE_EVENT_DIALOG,
	events: {
		'Default Locations Loaded': props<{
			defaultLocations: JobsV2EventLocation[],
		}>(),
		'Event Loaded': props<{
			event: JobDetailsV2Fragment['events'][number],
		}>(),
    'Close Create Event Dialog Button Clicked': emptyProps(),
		'Mutate Event Button Clicked': emptyProps(),
		'Reschedule Event Button Clicked': emptyProps(),
		'Event Type Selected': props<{
			eventType: EventType,
		}>(),
		'Event Status Selected': props<{
			status: EventStatuses
		}>(),
		'Event Title Input Changed': props<{
			eventTitle: string
		}>(),
		'Asset Selected': props<{
			selectedAsset: Asset,
		}>(),
		'Asset Unselected': props<{
			unselectedAsset: Asset,
		}>(),
		'Asset Autocomplete Search Fired': props<{
			query: string
		}>(),
		'Search Assets Loading': emptyProps(),
		'Search Assets Success': props<{
			assets: BaseAssetFragment[],
		}>(),
		'Search Assets Error': props<{
			error: Error,
		}>(),
		'Locations Selection Changed': props<{
			locations: JobsV2EventLocation[],
		}>(),
		'Attendees Selected': props<{
			selectedAttendee: CalendarEvent_AttendeeFragment,
		}>(),
		'Attendees Unselected': props<{
			unselectedAttendee: CalendarEvent_AttendeeFragment,
		}>(),
		'Attendees Autocomplete Search Fired': props<{
			query: string
		}>(),
		'Search Attendees Loading': emptyProps(),
		'Search Attendees Success': props<{
			users: FullUserFragment[],
		}>(),
		'Search Attendees Error': props<{
			error: Error,
		}>(),
		'Location Dropped': props<{
			previousIndex: number,
			currentIndex: number,
		}>(),
		'Location Duration Input Changed': props<{
			locationType: string,
			duration: number,
		}>(),
		'Create Event Success': props<{
			createdEvent: Job_CalendarEventFragment,
			jobId: string;
		}>(),
		'Create Event Error': props<{
			error: Error,
		}>(),
		'Update Event Success': props<{
			updatedEvent: BulkEditCalendarEventMutation['bulkEditCalendarEvent']['events'][number],
			jobId: string;
		}>(),
		'Update Event Error': props<{
			error: Error,
		}>(),
	},
});
